﻿﻿import { IContact } from './contact';

export interface IProductDetails {
    id: number;
    nextSteps: string;
    targetDate: string;
    closeDate: string;
    closedBy: IContact;
}
